export default {"src":"/_next/static/media/nmdp_whitetext.635364ee.svg","height":500,"width":1500,"blurWidth":0,"blurHeight":0};